import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatNumber,
  formatUnit,
  getEnergyDetailRows,
  getFyLabels,
  mergeRow,
  readFY,
  safeText,
  setCell,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Energy consumed from NR";

const SHEET_TITLE = "Details of energy consumed from non-renewable sources";

const FALLBACK_ROWS = [
  ["Total electricity consumption (D)", "electricityConsumption"],
  ["Total fuel consumption (E)", "fuelConsumption"],
  ["Energy consumption through other sources (F)", "energyConsumption"],
];

export function buildEnergyConsumedFromNRSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  const { current: fyCurrent, previous: fyPrevious } = getFyLabels(reportingYear);
  const energy = sectionC?.principle6?.essentialIndicators?.energyConsumptionIntensity || {};
  const unit = formatUnit(energy?.fromNonRenewableSource?.electricityConsumption?.currentUnit);

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 36;
  ws.getColumn("F").width = 18;
  ws.getColumn("G").width = 16;
  ws.getColumn("H").width = 16;

  let detailRows = getEnergyDetailRows(energy, false);
  if (!detailRows.length) {
    detailRows = FALLBACK_ROWS.map(([source, key]) => ({
      source,
      unit,
      current: readFY(energy?.fromNonRenewableSource?.[key], "current"),
      previous: readFY(energy?.fromNonRenewableSource?.[key], "previous"),
    }));
  }

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, { mergeEnd: COL_H });

  mergeRow(ws, TITLE_ROW, COL_D, COL_H, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Source of energy", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "Unit", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  detailRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.source), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.unit || unit), { align: "center" });
    setCell(ws, row, COL_G, formatNumber(item?.current), { align: "center" });
    setCell(ws, row, COL_H, formatNumber(item?.previous), { align: "center" });
  });

  return ws;
}
